// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'd57f9191f434670c08c3898b2ae6c6f07ba52ab7';
export const BUILD_NUMBER = '183';
export const BUILD_TIMESTAMP = '2026-07-01T09:55:30.735Z';
